import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import Settings from './Settings.jsx';
import './MainLayout.css';

const MainLayout = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated, logout } = useAuth();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleNavigation = (path) => {
        navigate(path);
        setIsMobileMenuOpen(false); // Close mobile menu after navigation
    };

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/');
            setIsMobileMenuOpen(false); // Close mobile menu after logout
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <div className="main-layout">
            <header className="main-header">
                <div className="header-content">
                    {/* Desktop Navigation */}
                    <div className="header-left desktop-nav">
                        <button 
                            className={`nav-button ${location.pathname === '/' || location.pathname.startsWith('/tournament/') || location.pathname.startsWith('/summary/') ? 'active' : ''}`}
                            onClick={() => handleNavigation('/')}
                        >
                            Turnieje
                        </button>
                        {isAuthenticated && (
                            <button 
                                className={`nav-button ${location.pathname === '/ranking' ? 'active' : ''}`}
                                onClick={() => handleNavigation('/ranking')}
                            >
                                Ranking
                            </button>
                        )}
                        {isAuthenticated && (
                            <button 
                                className={`nav-button ${location.pathname === '/ustawienia' ? 'active' : ''}`}
                                onClick={() => handleNavigation('/ustawienia')}
                            >
                                Ustawienia
                            </button>
                        )}
                    </div>
                    
                    <div className="header-right desktop-nav">
                        {isAuthenticated ? (
                            <button 
                                className="logout-btn"
                                onClick={handleLogout}
                            >
                                Wyloguj się
                            </button>
                        ) : (
                            <button 
                                className="login-btn"
                                onClick={() => {
                                    if (window.openLoginModal) {
                                        window.openLoginModal();
                                    }
                                }}
                            >
                                Zaloguj się
                            </button>
                        )}
                    </div>

                    {/* Mobile Hamburger Menu */}
                    <div className="mobile-nav">
                        <button 
                            className="hamburger-btn"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle menu"
                        >
                            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
                            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
                            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu Overlay */}
                {isMobileMenuOpen && (
                    <div className="mobile-menu-overlay" onClick={() => setIsMobileMenuOpen(false)}>
                        <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
                            <div className="mobile-menu-header">
                                <h3>Menu</h3>
                                <button 
                                    className="close-menu-btn"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="mobile-menu-content">
                                <div className="mobile-nav-buttons">
                                    <button 
                                        className={`mobile-nav-button ${location.pathname === '/' || location.pathname.startsWith('/tournament/') || location.pathname.startsWith('/summary/') ? 'active' : ''}`}
                                        onClick={() => handleNavigation('/')}
                                    >
                                        Turnieje
                                    </button>
                                    {isAuthenticated && (
                                        <button 
                                            className={`mobile-nav-button ${location.pathname === '/ranking' ? 'active' : ''}`}
                                            onClick={() => handleNavigation('/ranking')}
                                        >
                                            Ranking
                                        </button>
                                    )}
                                    {isAuthenticated && (
                                        <button 
                                            className={`mobile-nav-button ${location.pathname === '/ustawienia' ? 'active' : ''}`}
                                            onClick={() => handleNavigation('/ustawienia')}
                                        >
                                            Ustawienia
                                        </button>
                                    )}
                                </div>
                                <div className="mobile-auth-buttons">
                                    {isAuthenticated ? (
                                        <button 
                                            className="mobile-logout-btn"
                                            onClick={handleLogout}
                                        >
                                            Wyloguj się
                                        </button>
                                    ) : (
                                        <button 
                                            className="mobile-login-btn"
                                            onClick={() => {
                                                if (window.openLoginModal) {
                                                    window.openLoginModal();
                                                }
                                                setIsMobileMenuOpen(false);
                                            }}
                                        >
                                            Zaloguj się
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </header>
            
            <main className="main-content">
                {children}
            </main>
        </div>
    );
};

export default MainLayout;
